<template>
  <v-card>
    <v-card-title>
      <span class="text-h5">{{ titulo }}</span>
    </v-card-title>

    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-autocomplete v-model="dataForm.categoryId" :items="categories" label="Categoria" outlined
              :disabled="disabledForm"></v-autocomplete>
          </v-col>
          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-text-field v-model="dataForm.name" label="Codigo" outlined required
              :disabled="disabledForm"></v-text-field>
          </v-col>

          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-text-field v-model="dataForm.size" label="Talla" outlined required
              :disabled="disabledForm"></v-text-field>
          </v-col>

          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-autocomplete v-model="dataForm.sex" :items="itemSex" label="Sexo" auto-select-first outlined ref="cod"
              :disabled="disabledForm"></v-autocomplete>
          </v-col>

          <v-col cols="8" sm="8" md="8" class="pb-0">
            <v-text-field v-model="dataForm.description" label="Descripcion" outlined required
              :disabled="disabledForm"></v-text-field>
          </v-col>

          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-text-field v-model="dataForm.price" label="Precio" outlined required :disabled="disabledForm"
              type="number"></v-text-field>
          </v-col>

          <v-col cols="4" sm="4" md="4" class="pb-0">
            <v-select v-model="dataForm.supplierId" :items="suppliers" label="Proveedor" outlined
              :disabled="disabledForm"></v-select>
          </v-col>

          <v-col cols="4" sm="4" md="4" class="pb-0">
            <!-- <v-text-field v-model="dataForm.zone" label="Zona" outlined required
              :disabled="disabledForm"></v-text-field> -->
            <v-text-field v-model="dataForm.stockMin" label="Stock Minimo" outlined required :disabled="disabledForm"
              type="number"></v-text-field>
          </v-col>

          <v-col cols="8" sm="8" md="8" class="pb-0">
            <image-input v-model="avatar">
              <div slot="activator">
                <v-avatar size="300" v-if="avatarTmp">
                  <v-img :src="avatarTmp" alt="Imagen de Producto"> </v-img>
                </v-avatar>
                <v-avatar size="200" v-else class="grey lighten-3 mb-3">
                  <span>Agregar Foto</span>
                </v-avatar>
              </div>
            </image-input>
          </v-col>




        </v-row>
      </v-container>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="close">
        Volver
      </v-btn>
      <v-btn v-if="!disabledForm && isOk" color="blue darken-1" text @click="save">
        Guardar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import UserProfile from "../../data";
import { getSex } from "../../dataApi";
import ImageInput from '../../components/ImageInput.vue';
export default {
  components: {
    ImageInput
  },
  data: () => ({
    user: UserProfile.getUserData(),
    search: "",
    dialog: false,
    dialogDelete: false,
    avatar: null,
    avatarTmp: null,
    chosenFile: null,
    lugares: ["Cliente", "Instalación"],
    tiposPlanificacion: ["Programado", "No programado"],
    tiposCreador: [
      "Cliente administrador",
      "Cliente usuario final",
      "FC de la locación",
      "FC fuera de la locación",
    ],
    tiposServicios: [
      "Aseo tradicional",
      "Aseo terminal",
      "Aseo recurrente",
      "Programa de aseo",
      "Vidrios a nivel",
      "Vidrios en altura",
      "Limpieza en altura",
    ],
    gruposTareas: ["Fin de semana", "Cada 15 días", "Cada 30 días"],
    parametrosLugar: ["Dirección", "Recinto", "Piso", "Zona/Área"],
    tiposTicket: [
      "Capacitación",
      "Tarea de RRHH",
      "Tarea administrativa",
      "Aviso cambio RRHH",
      "Mantenimiento de equipos",
    ],
    asignacion: ["Cuadrilla", "Persona", "Cargo"],
    estadoTicket: ["No leído", "Abierto", "Resuelto", "Cerrado"],
    headers: [
      {
        text: "Título",
        align: "start",
        sortable: false,
        value: "titulo",
      },
      { text: "Tipo de ticket", value: "tipo" },
      // { text: "Descripción", value: "descripcion" },
      { text: "Lugar", value: "lugar" },
      { text: "Planificación", value: "tipoPlanificacion" },
      { text: "Tipo de Creador", value: "tipoCreador" },
      { text: "Servicio", value: "tipoServicio" },
      // { text: "Grupo de tareas", value: "grupoTarea" },
      { text: "Asignación", value: "asignado_a" },
      // { text: "Estado", value: "estado" },
      { text: "Creado por", value: "creado_por" },
      { text: "Acciones", value: "actions", sortable: false },
    ],
    itemSex: [],
  }),
  props: {
    titulo: {
      type: String,
      default: "Nuevo Producto",
    },
    dataForm: {
      type: Object,
      default: {},
    },
    categories: { type: Array, default: null },
    suppliers: { type: Array, default: null },
    disabledForm: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.dataForm?.photo != "") {
      this.avatarTmp = this.dataForm.photo;
    }
    this.itemSex = getSex();
  },
  methods: {
    close() {
      this.$emit("recibeTickect", undefined)
      this.avatar = null;
      //this.avatarTmp = null;
      this.chosenFile = null;
    },

    save() {
      this.dataForm.chosenFile = this.chosenFile;
      this.$emit("recibeTickect", this.dataForm)
    },
  },
  watch: {
    avatar() {
      if (this.avatar) {
        this.avatarTmp = this.avatar.imageURL
        this.chosenFile = this.avatar.imageFile
      }
    },
  },
  computed: {
    isOk() {
      const { categoryId, name, size, sex, description, price, supplierId, stockMin } = this.dataForm;
      return categoryId && name && size && sex && description && price && supplierId && stockMin;
    }
  }
};
</script>

<style lang="scss">
.combo-parametros {
  .v-select__selections {
    min-height: 56px !important;
  }
}

.theme--dark.v-chip.default {
  background: #f1f1f1;
  color: rgba(0, 0, 0, 0.87);
}

.v-text-field__details {
  display: none;
}
</style>
